import * as yup from "yup";

import { Shape } from "@/core/yup";
import i18n from "@/i18n";
import { validateBankAccount, validateVAT } from "@/validations";

import { CompanyFormType } from "../../formType";
import { CompanyFinancialFormType } from "./formType";

export const formSchemaFinancial = yup.object<{}, Shape<CompanyFinancialFormType>>({
    fiscalStatus: yup.string(),
    endOfFiscalYear: yup.date().nullable(),
    vatNumber: yup.string().test("vatNumber", i18n.t("Validations.Format"), function testVatNumber() {
        const { vatNumber } = this.parent;
        return validateVAT(vatNumber);
    }),
    vatExemption: yup.number().min(0).max(100).nullable(),
    bankAccountNumber: yup
        .string()
        .test("bankAccountNumber", i18n.t("Validations.Format"), function testAccountNumber() {
            const { bankAccountNumber } = this.parent;
            return validateBankAccount("2", bankAccountNumber);
        }),
    billingEmailAddress: yup.string().email(),
});

export const formSchemaFinancialStep = yup.object<{}, Shape<CompanyFormType>>({
    fiscalFinancial: formSchemaFinancial,
});
